/**
 * Display unit for time estimations
 */
export enum DisplayUnit {
  /** Display in hours */
  Hours = 0,
  /** Display in days */
  Days = 1
}

/**
 * Normalize DisplayUnit value (handle both string and number from API)
 */
export function normalizeDisplayUnit(value: DisplayUnit | string | number | undefined | null): DisplayUnit {
  if (value === undefined || value === null) {
    return DisplayUnit.Hours
  }
  // If it's already a number, return it
  if (typeof value === 'number') {
    return value as DisplayUnit
  }
  // If it's a string, convert it
  if (typeof value === 'string') {
    const normalized = value.toLowerCase()
    if (normalized === 'hours' || normalized === '0') return DisplayUnit.Hours
    if (normalized === 'days' || normalized === '1') return DisplayUnit.Days
  }
  return DisplayUnit.Hours // Default
}
